__turbopack_context__.v({
  "className": "andika_c93dd085-module__cEEP7G__className",
});
